const errors = {};

export { errors };
